<template>
    <div v-show="delShow" :class="{ 'view': isview, 'closeview': iscloseview}">
        <div class="view-bg"></div>
        <div class="view-dialog">
             <div style="text-align:center"> <strong>{{title}}</strong></div>
             <p class="view-text">{{cont}}</p>
             <div class="view-sub">
                 <div class="view-sub-cancel" @click="cancel" >{{$t('cancel')}}</div>
                 <Button  type="primary" :disabled='disabledDeL' :loading="disabledDeL" @click="confirm">{{$t('confirm')}}</Button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        showViewModel: Boolean,
        title:{
            type: String,
            default:'删除'
        },
        cont:{
            type: String,
            default:'确认删除？删除后将不可恢复！'
        },
    },
    name: "Models",
    data() {
        return {
            delShow: false,
            isview: true,
            iscloseview: false,
            disabledDeL:false
        }
    },
    created() {
        this.showViewModel = false;
    },
    methods: {
        cancel() {   //取消         
            this.isview = false;
            this.iscloseview = true;
            setTimeout(()=> {
                this.disabledDeL = false
                this.delShow = false;
            }, 300)
        },
        recancel() {            
            this.delShow = false;
            this.disabledDeL = false
        },
        showit() { 
            this.isview = true;
            this.iscloseview = false;
            this.delShow = true;            
        },
        confirm() { //确定
            this.disabledDeL = true
            this.$emit('ievent', '1');
            // setTimeout(() => {
            //     this.disabledDeL = false
            // }, 1800);
        }
    }
}
</script>
<style scoped>

@keyframes dialogBg {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
.view {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    animation: dialogBg 0.3s ease;
    z-index: 1016 !important;
}
  .ivu-layout-header div{
        line-height: normal;
    }
.view-bg {
    width: 100vw;
    height: 100vh;
    background-color: #000;
    opacity: 0.4;
    position: absolute;
    left: 0;
    top: 0;
}
.view-dialog {
    width: 380px;
    min-height: 150px;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    position: absolute;
    left: 50%;
    top: 15%;
    margin-left: -190px;
    z-index: 1000;
    animation: dialog 0.2s ease;
}
@keyframes dialog {
    0% {
        -webkit-transform: scale(0.8,0.8);
        -moz-transform:scale(0.8,0.8);
        transform: scale(0.8,0.8);
    }
    100% {
        -webkit-transform: scale(1,1);
        -moz-transform:scale(1,1);
        transform: scale(1,1);
    }
}
.closeview {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    animation: closeDialogBg 0.3s ease;
}
.closeview .view-dialog {
    width: 380px;
    height: 150px;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    position: absolute;
    left: 50%;
    top: 15%;
    margin-left: -190px;
    z-index: 1000;
    animation: closeDialog 0.3s ease;
}
@keyframes closeDialogBg {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
@keyframes closeDialog {
    0% {
        -webkit-transform: scale(1,1);
        -moz-transform:scale(1,1);
        transform: scale(1,1);  
    }
    100% {
        -webkit-transform: scale(0.8,0.8);
        -moz-transform:scale(0.8,0.8);
        transform: scale(0.8,0.8);
    }
}
.view-text {
    margin-top: 15px;
}
.view-sub {
    display: flex;
   justify-content: flex-end;
    margin-top: 30px;
}
.view-sub div {
    margin-left: 15px;
    height: 32px;
    line-height: 32px;
}
.view-sub-cancel {
    width: 60px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    margin-right: 20px;
}
.view-sub-cancel:hover {
    color: #2d8cf0;
}
.view-sub-confirm {
    width: 60px;
    height: 32px;
    background: #2d8cf0; 
    color: #fff;
    text-align: center;
    line-height: 32px;
    border-radius: 5px;
    cursor: pointer;
}
</style>
